import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import classes from './index.module.scss';
interface SocializationProps {
  adsCount?: number;
  url?: string;
}
type OnlineAdsProps = Pick<SocializationProps, 'adsCount'>;
type ShopLinkProps = Pick<SocializationProps, 'url'>;
const ShopLink = t0 => {
  const $ = _c(3);
  const {
    url
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="button-text">Vai allo Shop</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== url) {
    t2 = <a href={url} className={classes.anchor_button} rel="noopener">{t1}</a>;
    $[1] = url;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const OnlineAds = t0 => {
  const $ = _c(3);
  const {
    adsCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames("body-text", "book", "small", classes.body_text);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${adsCount || 0} annunc${adsCount === 1 ? "io" : "i"} online`;
  let t3;
  if ($[1] !== t2) {
    t3 = <div className={classes.online_ads}><p className={t1}>{t2}</p></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
const Socialization = t0 => {
  const $ = _c(3);
  const {
    adsCount,
    url
  } = t0;
  let t1;
  if ($[0] !== adsCount || $[1] !== url) {
    t1 = adsCount != undefined && url != undefined ? <aside className={classes.socialization}><OnlineAds adsCount={adsCount} /><ShopLink url={url} /></aside> : null;
    $[0] = adsCount;
    $[1] = url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
Socialization.displayName = 'BottomShopBox_Socialization';
export default Socialization;